module.exports = __webpack_public_path__ + "img/open-table-count-icon.ef9ba2cc.png";